import React, { useEffect, useState } from "react"
import { Box } from "@mui/material"
import { FxValidationProps } from "./FxValidation.props"
import { FormValidator } from "../helpers/FormValidator"

/**
 * @param value
 * @param validations
 * @param customErrors
 * @param onBlur
 * @param validationResult
 * @param model
 * @constructor
 */
export const FxValidation = ({
  value,
  validations = [],
  customErrors = [],
  onBlur,
  validationResult,
  model
}: FxValidationProps) => {
  const defaultErrors: any = {}
  const [errors, setErrors] = useState(defaultErrors)
  const [initialized, setInitialized] = useState(false)
  const hasError = (validation: any) => {
    let key = (typeof validation === "object") ? validation.key : validation
    return errors && errors[key]
  }
  const validationMessages: any = {
    required: "This field is required",
    comboRequired: "This field is required",
    email: "Please enter valid email",
    number: "This field should be number",
    alphaNumeric: "This field should be alphanumeric",
    mobile: "Please enter 10 digit number"
  }

  /**
   *
   * @param validationData
   */
  const updateErrors = (validationData: any) => {
    setErrors((prevState: any) => {
      return { ...prevState, ...validationData }
    })
  }

  /**
   *
   */
  const validate = () => updateErrors(FormValidator.validate({ value, validations, model }))

  /**
   *
   * @param validation
   */
  const getValidationMessage = (validation: any) => {
    let message
    if (typeof validation === "object") message = validation.message ? validation.message : validationMessages[validation.key]
    else message = validationMessages[validation]
    return message
  }

  useEffect(() => {
    initialized ? validate() : setInitialized(true)
  }, [value])

  useEffect(() => {
    if (onBlur) validate()
  }, [onBlur])

  useEffect(() => {
    updateErrors(validationResult)
  }, [validationResult])

  /**
   * @param validation
   */
  const _renderError = (validation: any,index:any) =>
    hasError(validation) &&
    <Box className="box-validation-message" key={index}>
      {getValidationMessage(validation)}
    </Box>

  return (
    <>
      {validations && validations.length > 0 &&
        <Box className="fx-validation">
          {validations.map((validation: any, index: any) => _renderError(validation,index))}
        </Box>
      }
      {customErrors && customErrors.length > 0 &&
        <Box className="fx-validation">
          {customErrors.map((error: any, index: any) => <Box key={index} className="box-validation-message">{error.message}</Box>)}
        </Box>
      }
    </>
  )
}
